<template>
  <div>
    <div class="group-input col-12 row q-mt-sm">
      <div class="row">
        <label for="nome_nap">Nome da NAP</label>
      </div>
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.nome_nap"
        name="nome_nap"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <div class="row">
        <RequiredLabel
          title="Qual a porta da NAP"
          name="porta_nap"
          v-if="typeOs === BACKBONE_GPON_PROBLEMA || isFieldRequiredByAtendimento('GPON')"
        />
        <label
          for="porta_nap"
          v-else
          >Qual a porta da NAP</label
        >
      </div>
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        type="number"
        color="red-9"
        use-input
        v-model="itemOsContract.porta_nap"
        name="porta_nap"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="
          typeOs === BACKBONE_GPON_PROBLEMA || isFieldRequiredByAtendimento('GPON')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <div class="row">
        <RequiredLabel
          title="Quais são as casas conectadas a NAP"
          name="casas_conectadas_nap"
          v-if="typeOs === BACKBONE_GPON_PROBLEMA || isFieldRequiredByAtendimento('GPON')"
        />
        <label
          for="casas_conectadas_nap"
          v-else
          >Quais são as casas conectadas a NAP</label
        >
      </div>
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.casas_conectadas_nap"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="casas_conectadas_nap"
        :rules="
          typeOs === BACKBONE_GPON_PROBLEMA || isFieldRequiredByAtendimento('GPON')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <label for="endereco_nap">Endereço da NAP</label>
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.endereco_nap"
        name="endereco_nap"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
      />
    </div>
  </div>
</template>

<script>
  import { BACKBONE_GPON_PROBLEMA } from "@/utils/constans/specialCodes";
import { inject } from "vue";
import RequiredLabel from "../RequiredLabel.vue";

  export default {
    name: "NapForm",
    components: { RequiredLabel },
    props: {
      itemOsContract: Object,
      typeOs: Number,
    },
    setup(props, { emit }) {
      const isFieldRequiredByAtendimento = inject(
        "isFieldRequiredByAtendimento"
      );

      return {
        isFieldRequiredByAtendimento,
        BACKBONE_GPON_PROBLEMA,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
